import { render, staticRenderFns } from "./ProductItemFeatureCreate.vue?vue&type=template&id=9e53555c&"
import script from "./ProductItemFeatureCreate.vue?vue&type=script&lang=js&"
export * from "./ProductItemFeatureCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports